import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import CustomInput from '../Components/CustomInput';
import { connect } from 'react-redux';
import CustomButton from './CustomButton';


class ConfirmationAlert extends Component {
    render() {
        const {
            BodyFirstContent, BodySecondContent, BodyThirdContent, BodyForthContent, BodyFifthContent, confirmationButtonContent, cancelButtonContent, remarkInput, t, placeholder, errorLabel, value, onChange, remarkName, saveShow, cancelShow, deleteIconVissable } = this.props;
        return (
            <div className="modalinnerbody">
                {deleteIconVissable &&
                <div className='deleteIconBox'><i className="fa fa-trash" aria-hidden="true"></i></div> 
                }
                <p>{BodyFirstContent} <span>{BodySecondContent}</span> {BodyThirdContent} {BodyForthContent} {BodyFifthContent}</p>
                {remarkInput ?
                    <div className="remarkinputinner">
                        <CustomInput
                            parentClassName="input_field_inner"
                            errorLabel={errorLabel}
                            name={remarkName}
                            type="textarea"
                            value={value}
                            labelPresent={true}
                            placeholder={placeholder}
                            onChange={onChange}
                        />
                    </div> : null}
                <div className="col-md-12 modfooterbtn">
                    {saveShow ? <>
                        <CustomButton
                            onClick={this.props.deleteConfirmButton}
                            className="savebtn"
                            children={confirmationButtonContent}
                        />
                    </> : null
                    }
                    {cancelShow ?
                        <>
                            <CustomButton
                                onClick={this.props.deleteCancleButton}
                                className="cancelbtn"
                                children={cancelButtonContent}
                            />
                        </> : null
                    }
                </div>
            </div>
        );
    }
}


ConfirmationAlert.defaultProps = {
    BodyFirstContent: "",
    BodySecondContent: "",
    BodyThirdContent: "",
    BodyForthContent: "",
    BodyFifthContent: "",
    confirmationButtonContent: "",
    cancelButtonContent: "",
    remarkInput: false,
    placeholder: "",
    remarkName: "deleteRemarkName",
    saveShow: true,
    cancelShow: true,
    deleteIconVissable: false
}

const mapStateToProps = (globalState) => {
    return {

    };
}

export default connect(mapStateToProps, {})(ConfirmationAlert);
